import { TextField, Grid } from "designSystem/index";
import React from "react";
import InputAdornment from "@mui/material/InputAdornment";
import IconAttachFile from "@mui/icons-material/AttachFile";
import IconCheck from "@mui/icons-material/Check";
import IconCancel from "@mui/icons-material/Cancel";

export default () => (
	<Grid container spacing={5}>
		<Grid
			container
			item
			spacing={8}
			xs={12}
		>
			<Grid item>
				<TextField
					defaultValue=""
					label="Text Field"
					placeholder="Hint"
				/>
			</Grid>
			<Grid item>
				<TextField
					defaultValue="Hello World"
					label="With default text"
					placeholder="Hint"
				/>
			</Grid>
			<Grid item>
				<TextField
					defaultValue=""
					disabled
					label="Disabled"
					placeholder="Hint"
				/>
			</Grid>
			<Grid item>
				<TextField
					defaultValue="Hello World"
					disabled
					label="Disabled with text"
					placeholder="Hint"
				/>
			</Grid>
		</Grid>
		<Grid
			container
			item
			spacing={8}
			xs={12}
		>
			<Grid item>
				<TextField
					defaultValue=""
					helperText="This is helper text"
					label="With helper text"
					placeholder="Hint"
				/>
			</Grid>
			<Grid item>
				<TextField
					InputProps={{ startAdornment: (<InputAdornment position="start"><IconAttachFile /></InputAdornment>) }}
					defaultValue=""
					label="With Icon"
					placeholder="Hint"
				/>
			</Grid>
			<Grid item>
				<TextField
					InputProps={{ startAdornment: (<InputAdornment position="start"><IconCheck /></InputAdornment>) }}
					defaultValue="Hello World"
					label="With default text"
					placeholder="Hint"
				/>
			</Grid>
			<Grid item>
				<TextField
					InputProps={{ startAdornment: (<InputAdornment position="start"><IconCancel /></InputAdornment>) }}
					defaultValue=""
					disabled
					label="Disabled"
					placeholder="Hint"
				/>
			</Grid>
		</Grid>
	</Grid>
);

